import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
function ContinueOrder_1({ item }) {
  const customization = staticComponentValueConverter(item?.customization);

  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const products = useSelector(state => state.themeSlice.products);
  const firstProduct = products && Object.values(products)?.[0];

  return (
    <>
      <div className="w-full h-full relative flex flex-col p-2">
        <div
          style={{
            marginBottom: 10,
            backgroundColor: '#F3F3F3',
            padding: 10,
            gap: 5,
            borderRadius: 5,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: staticValues[11],
                color: '#9F9F9F',
              }}
            >
              Ara Toplam
            </div>
            <div
              style={{
                fontSize: staticValues[10],
                color: '#ACACAC',
              }}
            >
              ₺ 976.00
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: staticValues[11],
                color: '#9F9F9F',
              }}
            >
              Kasım İndirimi
            </div>
            <div
              style={{
                fontSize: staticValues[10],
                color: '#F76363',
              }}
            >
              -₺ 430.00
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: 5,
              paddingTop: 5,
              borderBottom: '1px solid #E5E5E5',
            }}
          >
            <div
              style={{
                fontSize: staticValues[12],
                color: '#000000',
              }}
            >
              Toplam
            </div>
            <div
              style={{
                fontSize: staticValues[12],
                color: '#000000',
              }}
            >
              ₺ 446.00
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              paddingBottom: 5,
              paddingTop: 5,
              borderBottom: '1px solid #E5E5E5',
              fontSize: staticValues[12],
            }}
          >
            Kupon Kodu Ekle{' '}
            <svg width="14px" height="16px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                fill="#5C5F62"
              />
            </svg>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 5,
            }}
          >
            <div
              style={{
                flex: 1,
              }}
            >
              <div
                style={{
                  borderWidth: 1,
                  borderColor: '#000000',
                  borderRadius: 5,
                  borderStyle: 'solid',
                  display: 'flex',
                  gap: 5,
                  backgroundColor: '#FFFFFF',
                  alignItems: 'center',
                }}
              >
                <div style={{ padding: '5px 10px' }}>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.58203 0.12207L16.0123 0.703235L16.5838 8.25909L8.8522 16.1221L0.850464 7.98433L8.58203 0.12207ZM9.12236 1.60663L2.85125 7.98433L8.8522 14.088L15.1233 7.70957L14.6947 2.0425L9.12236 1.60663ZM11.8523 4.9325C11.7871 4.8638 11.709 4.80901 11.6228 4.77131C11.5365 4.73362 11.4437 4.71377 11.3498 4.71294C11.2558 4.71211 11.1627 4.73031 11.0758 4.76648C10.9889 4.80264 10.9099 4.85605 10.8435 4.92358C10.7771 4.99112 10.7246 5.07142 10.689 5.15982C10.6535 5.24821 10.6356 5.34293 10.6364 5.43843C10.6372 5.53393 10.6567 5.62831 10.6938 5.71607C10.7309 5.80382 10.7847 5.88319 10.8523 5.94954C10.9857 6.08056 11.1643 6.15305 11.3498 6.15142C11.5352 6.14978 11.7126 6.07413 11.8437 5.94078C11.9748 5.80742 12.0492 5.62702 12.0508 5.43843C12.0524 5.24984 11.9811 5.06815 11.8523 4.9325ZM9.85224 3.91546C10.0486 3.71239 10.2826 3.55088 10.5407 3.44024C10.7988 3.32959 11.0759 3.27202 11.356 3.27082C11.6361 3.26963 11.9136 3.32484 12.1726 3.43328C12.4316 3.54172 12.6669 3.70124 12.865 3.90263C13.063 4.10402 13.22 4.3433 13.3266 4.60667C13.4333 4.87004 13.4877 5.15228 13.4866 5.43712C13.4855 5.72196 13.4289 6.00376 13.3202 6.26627C13.2115 6.52877 13.0527 6.76678 12.8531 6.96658C12.4541 7.36584 11.9162 7.58861 11.3565 7.58636C10.7968 7.58411 10.2606 7.35702 9.86476 6.95456C9.46893 6.55209 9.24551 6.00687 9.24316 5.43763C9.24082 4.8684 9.45974 4.32129 9.85224 3.91546Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div
                  style={{
                    flex: 1,
                    color: '#B3B3B3',
                    fontSize: staticValues[9],
                    textAlign: 'start',
                  }}
                >
                  Kupon kodunuzu giriniz.
                </div>
                <div
                  style={{
                    backgroundColor: '#000000',
                    color: '#FFFFFF',
                    fontSize: staticValues[10],
                    padding: '5px 10px',
                  }}
                >
                  Uygula
                </div>
              </div>
            </div>
            <div>
              <svg
                fill="#000000"
                width="14px"
                height="14px"
                viewBox="-0.061 0 0.333 0.333"
                xmlns="http://www.w3.org/2000/svg"
                class="cf-icon-svg"
              >
                <path d="M0.199 0.239A0.018 0.018 0 0 1 0.174 0.264L0.105 0.196 0.036 0.264a0.018 0.018 0 1 1 -0.025 -0.025l0.069 -0.069L0.011 0.101a0.018 0.018 0 1 1 0.025 -0.025L0.105 0.145l0.069 -0.069a0.018 0.018 0 0 1 0.025 0.025L0.13 0.17z" />
              </svg>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              paddingBottom: 5,
              paddingTop: 5,
              borderBottom: '1px solid #E5E5E5',
              fontSize: staticValues[12],
            }}
          >
            Sipariş Notu Ekle{' '}
            <svg width="14px" height="16px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                fill="#5C5F62"
              />
            </svg>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 5,
            }}
          >
            <div
              style={{
                flex: 1,
              }}
            >
              <div
                style={{
                  borderWidth: 1,
                  borderColor: '#000000',
                  borderRadius: 5,
                  borderStyle: 'solid',
                  display: 'flex',
                  gap: 5,
                  backgroundColor: '#FFFFFF',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    flex: 1,
                    color: '#B3B3B3',
                    fontSize: staticValues[9],
                    textAlign: 'start',
                    height: 50,
                    padding: '5px 10px',
                  }}
                >
                  Sipariş notunuzu giriniz.
                </div>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 5,
              }}
            >
              <div
                style={{
                  backgroundColor: '#000000',
                  padding: '3px 3px',
                }}
              >
                <svg
                  fill="#FFFFFF"
                  width="16px"
                  height="16px"
                  viewBox="-0.061 0 0.333 0.333"
                  xmlns="http://www.w3.org/2000/svg"
                  class="cf-icon-svg"
                >
                  <path d="M0.199 0.239A0.018 0.018 0 0 1 0.174 0.264L0.105 0.196 0.036 0.264a0.018 0.018 0 1 1 -0.025 -0.025l0.069 -0.069L0.011 0.101a0.018 0.018 0 1 1 0.025 -0.025L0.105 0.145l0.069 -0.069a0.018 0.018 0 0 1 0.025 0.025L0.13 0.17z" />
                </svg>
              </div>
              <div
                style={{
                  backgroundColor: '#000000',
                  padding: '3px 3px',
                }}
              >
                <svg width="16px" height="16px" viewBox="0 0 0.48 0.48" xmlns="http://www.w3.org/2000/svg">
                  <g id="Complete">
                    <g id="tick">
                      <path
                        points="3.7 14.3 9.6 19 20.3 5"
                        fill="none"
                        stroke="#FFFFFF"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="0.04"
                        d="M0.074 0.286L0.192 0.38L0.406 0.1"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            padding: staticValues[10],
            gap: 2,
            backgroundColor: customization?.buttonBackgroundColor,
            color: customization?.buttonTextColor,
            fontSize: staticValues[14],
            borderRadius: 5,
            marginBottom: staticValues[10],
          }}
        >
          <div>CHECKOUT</div>
          <div>
            <svg width="10" height="10" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5626 10.5554L2.11223 19L0 16.8892L7.39429 9.5L0 2.11078L2.11223 0L10.5626 8.44461C10.8427 8.72455 11 9.10417 11 9.5C11 9.89583 10.8427 10.2755 10.5626 10.5554Z"
                fill={customization?.buttonTextColor}
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContinueOrder_1;
